<template>
  <div
    class="room-item"
    :class="[{ selected: isSelected }]"
    data-component="booking-room-item"
  >
    <div
      v-if="numberOfUnits < 5 && !isSelected"
      class="room-ribbon"
    >
      {{ tc('booking.roomsLeft', { numberOfUnits: numberOfUnits }) }}
    </div>
    <div class="room-image">
      <div
        v-if="isSelected"
        class="current-selected"
      >
        {{ tc('booking.currentSelection') }}
      </div>
      <carousel
        :key="`carousel-${room.synXisID}`"
        selector=".carousel-wrapper"
        variant="show1"
      >
        <section class="carousel media-only">
          <div class="carousel-wrapper show1">
            <div
              v-for="(item, i) in room.images"
              :key="`${i}-${item.src}-image-${room.synXisID}`"
              class="slide"
            >
              <div class="slide-image">
                <picture
                  :key="`${i}-${item.src}-image-${room.synXisID}-picture`"
                  v-lazyload="{
                    src: item.src,
                    set: [
                      { width: '800', height: '450', breakpoint: 'xs' },
                      { width: '800', height: '450', breakpoint: 'md' }
                    ],
                    fit: 'crop',
                    align: 'center'
                  }"
                  class="image-wrapper"
                >
                  <img
                    class="image"
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                    :alt="item.alt"
                  >
                </picture>
              </div>
            </div>
          </div>
        </section>
      </carousel>
    </div>

    <div class="room-content-wrapper">
      <div class="room-content">
        <div class="room-title">
          <span class="title">{{ room.title }}</span>
          <div
            v-if="room.roomPageUrl"
            class="room-view-more"
          >
            <a
              :href="room.roomPageUrl"
              target="_blank"
            >
              {{ tc('booking.seeDetails') }}
            </a>
          </div>
        </div>
        <div class="room-details">
          <div class="room-metrics">
            <span
              v-if="room.squareMeters"
              class="square-meters"
            >
              {{ room.squareMeters }} {{ tc('booking.squareMeters') }}
            </span>
            <div
              v-if="room.squareFeet"
              class="marker"
            />
            <span
              v-if="room.squareFeet"
              class="square-feet"
            >
              {{ room.squareFeet }} {{ tc('booking.squareFeet') }}
            </span>
          </div>
        </div>
        <div class="room-info">
          <div
            v-if="room.shortDescription"
            class="room-description"
          >
            {{ shortDescription }}
          </div>
          <form class="mohg-form select-bed">
            <fieldset>
              <legend class="sr-only">
                {{ tc('booking.selectBed') }}
              </legend>
              <div class="input dropdown">
                <select
                  :id="`select-bed-type-${room.synXisID}`"
                  v-model="selectedBed"
                  data-field-type="DropdownList"
                >
                  <option
                    v-for="(bed, i) in bedTypes"
                    :key="`${bed.synXisID}-${bed.title}-bed`"
                    :value="i"
                  >
                    {{ bed.title }}
                  </option>
                </select>
                <label
                  :for="`select-bed-type-${room.synXisID}`"
                  class="floating"
                >
                  {{ tc('booking.selectBed') }}
                </label>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      <rate-list
        :room="room"
        :bed-type="bedType"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import RateList from '@components/04.booking/booking-wizard/pages/room-list/components/rate-list'

  export default {
    name: 'RoomCard',
    components: {
      RateList
    },
    props: {
      room: {
        type: Object,
        required: true
      },
      filter: {
        type: String
      }
    },
    data: () => ({
      selectedBed: 0
    }),
    computed: {
      ...mapState('booking', ['query']),
      ...mapGetters('rooms', { synXisIds: 'roomsIds' }),
      ...mapGetters('cart', ['bedsIds']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('booking', ['currentRoom']),
      isSelected() {
        return this.bedTypeCodes.includes(`${this.currentRoom?.roomTypeCode}-${this.currentRoom?.sitecoreContent?.bed?.title}`)
      },
      currentBedType() {
        return `${this.currentRoom?.bedTypeCode}-${this.currentRoom?.sitecoreContent?.bed?.title}`
      },
      bedTypes() {
        return this.room.bedType.filter((b) => this.synXisIds.includes(b.synXisID)).filter((b) => (this.filter === 'accessible' ? b.accessible : true))
      },
      bedTypeCodes() {
        return this.bedTypes.map((b) => `${b.synXisID}-${b.title}`)
      },
      bedType() {
        return this.bedTypes[this.selectedBed]
      },
      bedsInCart() {
        return this.bedsIds.filter((b) => b === this.bedType?.synXisID).length
      },
      defaultBedTypeIndex() {
        return this.bedTypes
          .map((bed, i) => ({ ...bed, index: i }))
          .find((bed) => `${bed.synXisID}-${bed.title}` === this.currentBedType || bed.synXisID === this.query.bedType)?.index
      },
      shortDescription() {
        const maxChars = 170
        if (this.room.shortDescription.length > maxChars) {
          return `${this.room.shortDescription.slice(0, maxChars)}...`
        }
        return this.room.shortDescription
      },
      numberOfUnits() {
        return this.bedType && (this.bedType.numberOfUnits - this.bedsInCart)
      },
      roomRates() {
        return this.room.rates.filter((r) => r.roomTypeCode === this.bedType.synXisID)
      }
    },
    watch: {
      defaultBedTypeIndex(val) {
        this.selectedBed = val || 0
      }
    },
    mounted() {
      if (typeof this.defaultBedTypeIndex === 'number') {
        this.selectedBed = this.defaultBedTypeIndex
      }
    },
    methods: {
    }
  }
</script>
